<template>
  <div class="header">
    <div class="header-top">
      <div class="content">山东省科教人才发展继续教育平台</div>
    </div>
    <div class="header-bar">
      <nav class="content">
        <ul class="flex-sb">
          <li @click="jump(item)" v-for="(item, key) in menuList">
            {{ item.name }}
           <span></span>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  props: {},
  data() {
    return {
      //建设要闻 1 通知公告2 政策法规3 帮助中心4
      menuList: [
        {
          name: "首页",
          url: "/",
        },
        // {
        //   name: "建筑要闻",
        //   url: "/news",
        //   type: "1",
        // },
        {
          name: "通知公告",
          url: "/notices",
          type: "2",
        },
        {
          name: "政策法规",
          url: "/policy",
          type: "3",
        },
        {
          name: "课程中心",
          url: "/courseLearning",
        },
        // {
        //   name: "课程学习",
        //   url: "/courseLearning",
        // },
        {
          name: "我的课程",
          url: "/myCourses",
        },
        {
          name: "个人中心",
          url: "/usercenter",
        },
      ],
    };
  },
  methods: {
    jump(data) {
      if(!localStorage.getItem("token") && (data.url == '/usercenter'||data.url =='/myCourses')){
        return this.errorTips('登录状态失效，请重新登录')
      }
      if (this.$route.path != data.url) {
        this.$router.push({
          path: data.url,
        });
      }
    },
    errorTips(message, type = "warning") {
      this.$notify({
        title: "提示",
        message,
        type,
      });
    },
  },
};
</script>

<style lang="less" scoped>
.header {
  height: 276px;

  &-top {
    min-width: 1600px;
    height: 194px;
    background-image: url("../assets/image/header/bg.jpg");
    background-size: 100% 194px;
    color: #1b1c80;
    font-size: 39px;
    font-weight: bold;
    padding-top: 70px;
    .content {
      padding-left: 90px;
    }
  }

  &-bar {
    height: 82px;
    background-color: #1265cc;
    line-height: 82px;
    min-width: 1600px;
    ul {
      padding: 0 116px;
      color: #fff;
      font-size: 16px;
      cursor: pointer;
      li{
        position: relative;
        span{
          position: absolute;
          top:0;
          bottom: 0;
          width: 200px;
          left:50%;
          margin-left: -100px;
        }
      }
    }
  }
}
</style>
